import { ImagesModule } from '@sparro/app/shared/components/images/images.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@sparro/app/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';

import { CompDetailSidenavComponent } from './components/comp-detail-sidenav/comp-detail-sidenav.component';
// import { LoaderModule } from '@sparro/app/shared/components/loader/loader.module';
import { ButtonsModule } from '@sparro/app/shared/components/buttons/buttons.module';
import { PipesModule } from '@sparro/app/shared/pipes/pipes.module';
import { NavigationButtonComponent } from '@sparro/app/shared/components/buttons/blueprints/navigation-button/navigation-button.component';
import { DirectiveModule } from '@sparro/app/shared/directives/directive.module';

@NgModule({
  declarations: [
    CompDetailSidenavComponent
  ],
  entryComponents: [
    NavigationButtonComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    // LoaderModule,
    ButtonsModule,
    PipesModule,
    DirectiveModule,
    ImagesModule
  ],
  exports: [
    CompDetailSidenavComponent
  ]
})
export class SharedModule { }
